exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hotauth-tigger {\r\n    background: #FFFFFF;\r\n    bottom: 12px;\r\n    margin-left: 16px;\r\n    margin-right: 16px;\r\n    width:100%;\r\n}", ""]);

// exports
